import React from "react";
import type { useChatMessagesControl } from "src/chats/hooks/useChatMessagesControl.hooks";

export const ChatMessagesContext = React.createContext<Pick<
  ReturnType<typeof useChatMessagesControl>,
  "messages" | "clearMessages" | "waitForMessage"
> | null>(null);
